"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var SkeletonGroup_1 = __importDefault(require("atomicComponents/atoms/Skeleton/SkeletonGroup"));
var PREFIX = 'DefaultTeams';
var classes = {
    wrapper: "".concat(PREFIX, "-wrapper"),
    noData: "".concat(PREFIX, "-noData"),
    defaultAnnualSpend: "".concat(PREFIX, "-defaultAnnualSpend"),
};
var StyledBox = (0, styles_1.styled)(material_1.Box)(function (_a) {
    var _b;
    var _c;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(classes.wrapper)] = {
            minHeight: 80,
            marginBottom: theme.spacing(3),
            padding: theme.spacing(0, 6.875, 0, 3),
            borderRadius: theme.spacing(1.25),
            border: "1px solid ".concat(theme.palette.grey[400]),
            position: 'relative',
            width: '100%',
        },
        _b[".".concat(classes.noData)] = {
            borderRadius: 12,
            backgroundColor: theme.palette.grey[500],
            padding: theme.spacing(1),
        },
        _b[".".concat(classes.defaultAnnualSpend)] = {
            fontWeight: theme.typography.fontWeightBold,
            color: (_c = theme.palette.neutral) === null || _c === void 0 ? void 0 : _c.light,
        },
        _b);
});
var DefaultTeams = function () { return ((0, jsx_runtime_1.jsx)(StyledBox, __assign({ className: classes.wrapper, display: "flex", alignItems: "center", flexWrap: "nowrap" }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, justifyContent: "space-between", alignItems: "center", wrap: "nowrap" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 4, item: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, { width: 125, className: classes.noData }) })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: 4, item: true, container: true, alignItems: "center", wrap: "nowrap" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "circular", width: 24, height: 24 }), (0, jsx_runtime_1.jsx)(SkeletonGroup_1.default, { children: __spreadArray([], __read(Array(5).keys()), false).map(function (el) { return ((0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "circular", width: 24, height: 24 }, el)); }) })] })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: 4, item: true, container: true, alignItems: "center", justifyContent: "flex-end", wrap: "nowrap" }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", alignItems: "center", justifyContent: "flex-end", flexWrap: "nowrap" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body1", className: classes.defaultAnnualSpend }, { children: "$" })), (0, jsx_runtime_1.jsx)(material_1.Box, { className: classes.noData, mx: 1, width: 50 }), (0, jsx_runtime_1.jsx)(material_1.Box, { className: classes.noData, mr: 0.5, width: 30 })] })), (0, jsx_runtime_1.jsx)(SkeletonGroup_1.default, { children: __spreadArray([], __read(Array(5).keys()), false).map(function (el) { return ((0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "circular", width: 24, height: 24 }, el)); }) })] }))] })) }))); };
exports.default = DefaultTeams;
